import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { MatRadioChange } from '@angular/material/radio';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { DatePipe } from '@angular/common'
import { RoleLevel } from '../services/settingService/setting.enum';

@Component({
  selector: 'app-manage-singletasktemplates',
  templateUrl: './manage-singletasktemplates.component.html',
  styleUrls: ['./manage-singletasktemplates.component.scss']
})
export class ManageSingleTaskTemplatesComponent implements OnInit {

  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  templateList: any;
  value = '';
  filterText: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  taskTemplateList: any = [] = [];

  updateformDialog: FormGroup;
  taskTemplateID: number = 0;
  spinner: boolean = false;
  taskListFolder: any = [] = [];
  taskListFolderSharedWithMe: any = [] = [];
  taskListFolderID: number = 0;
  taskListFolderIDSharedWithMe: number = 0;
  ButtonForFolder: boolean = false;
  SendEmailList: any[] = [];
  SendMobileList: any[] = [];
  AddTaskListEmailResult: any = [];
  addButtonShow: boolean = false;
  emailid: string = "";
  mobileNo: string = "";
  selectedTaskCategoryID:number=0;
  categoryTypeForSingleTask:number=0;
  rolesAsssign: any[] = [];
  showOrgnizationLevelCheckbox: boolean = false;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private settingsService: SettingService, private encryptionAlgo: EncryptionService,
    private httpClient: HttpClient, private constant: Constants,private customValidator: CustomvalidationService,
    public datepipe: DatePipe) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }


  ngOnInit(): void {

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      var admin = [];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      admin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin
        || m.roleLevel == RoleLevel.OrganizationAdmin || m.roleLevel == RoleLevel.OfficeAdmin);
      if (admin.length > 0) {
        this.showOrgnizationLevelCheckbox = true;
      } else {
        this.showOrgnizationLevelCheckbox = false;
      }
    }
    this.getTaskTemplatesForSingleTask();  
  }
 
  getTaskTemplatesForSingleTask() {
    this.loaderService.show();
    var ReqModel = {
      categoryID: Number(this.selectedTaskCategoryID),
      templateType: Number(this.categoryTypeForSingleTask),
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getSingleTaskTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskTemplateList = response.data.tasks;                 
          if (this.taskTemplateList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }         
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskTemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.taskTemplateList = [];
        this.ShowNoRecordFound = true;
        this.loaderService.hide();
      }
    });
  }


  UpdateTaskDialog(templateRef: TemplateRef<any>, task: any) {
    let group = {};
    this.updateformDialog = new FormGroup(group);
    this.taskTemplateID = task.taskId;//task.taskTemplateID;
    this.updateformDialog.addControl('taskTemplateName', this.formBuilder.control(''));
    this.updateformDialog.controls['taskTemplateName'].setValue(task.templateName);
    this.dialog.open(templateRef);
    this.updateformDialog.markAsPristine();
  }


  UpdateTaskTemplate(data) {
    let ReqModel = {
      taskTemplateID: this.taskTemplateID,
      taskTemplateName: data.taskTemplateName,
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.spinner = true;
    this.updateformDialog.markAsPristine();
    this.settingsService.renameSingleTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.dialog.closeAll();
          this.toastr.success('Task template update successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplatesForSingleTask();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.error('Task template update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.spinner = false;
        this.loaderService.hide();
        this.toastr.error('Task template update failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  UpdateTemplateToggle(task: any, event: any) {
    this.loaderService.show();
    var ReqModel = {
      taskTemplateID: task.taskId, //taskTemplateID,
      activate: event.checked,
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
    }
    this.settingsService.activeSingleTaskTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Status updated successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskTemplatesForSingleTask();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.loaderService.hide();
          this.toastr.error('Status update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.loaderService.hide();
        this.toastr.error('Status update failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  closeUpdate() {
    this.updateformDialog.reset();
    this.dialog.closeAll();
  }



  //========== For Delete Record ==============//
  selectedRecordDelete: any = [] = [];
  showOptionForDelete: boolean = false;

  selectRecordForDelete(event, temp) {
    if (event.checked) {
      let ReqModel = {
        selectedRecord: temp.taskId
      };
      this.selectedRecordDelete.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDelete.findIndex((itm) => itm.selectedRecord === temp.taskId);
      if (removeIndex !== -1) this.selectedRecordDelete.splice(removeIndex, 1);
    }
    if (this.selectedRecordDelete.length > 0) {
      this.showOptionForDelete = true;
    }
    else {
      this.showOptionForDelete = false;
      this.selectedRecordDelete = [];
    }

  }



  deleteMultipleTaskTemplates() {
    const message = `Are you sure you want to delete selected templates?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var selectedtasklist = [];
          if (this.selectedRecordDelete.length > 0) {
            for (var i = 0, len = this.selectedRecordDelete.length; i < len; ++i) {
              const taskid = this.selectedRecordDelete[i].selectedRecord;
              selectedtasklist.push(taskid);
            }
          }
          var reqModel = {
            tasktemplateIDs: selectedtasklist,
            userID: this.currentUser.UID,
            officeID: Number(this.myOfficeID),
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId)
          }
          this.loaderService.show();
          this.settingsService.removeSingleTaskTemplates(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.success('Single Task templates deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.getTaskTemplatesForSingleTask();
              } else {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.error('Single Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showOptionForDelete = false;
              this.selectedRecordDelete = [];
              this.loaderService.hide();
              this.toastr.error('Single Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }



  // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.mobileNo);
  }
  //=========================//

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
 
  onTaskListTabChangeForTaskImport($event) {

    if($event.value == "My Template"){
      this.categoryTypeForSingleTask=0;
    }
    if($event.value == "Organization"){
      this.categoryTypeForSingleTask=2;
      if(this.showOrgnizationLevelCheckbox==false){
        
      }
     
    }   
    this.getTaskTemplatesForSingleTask();   
  }
  
}